// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__R2ja_","detailsBorder":"styles_detailsBorder__3xGpD"};